// pwa-src/components/cards/playerCards/v2/PlayerCard.ts
import {
  CalculatedPlayer,
  LookupDetails,
} from '@alienheadwars/football-card-manager-model'; // Added Attribute import
import React from 'react';
// import Avatar as MUIavatar from '@mui/material/Avatar';

//TODO move away from css files
import '@fontsource/norwester';
import { PopupOnOverlayComponent } from '../../base/overlay/PopupOnOverlay';
import { CardDimensions, LargeCard, SmallCard } from './CardDimensions';
import { PlayerCardComponent } from './PlayerCard';

interface ExpandablePlayerCardProps {
  key?: string;
  player: CalculatedPlayer | LookupDetails;
  dimensions?: CardDimensions;
  onClick?(): void;
  actions?: React.ReactNode;
  // margin?: boolean
  blockExpand?: boolean;
  expandedCardSize?: CardDimensions;
  alternateChildren?: any;
}

export const ExpandablePlayerCard = (props: ExpandablePlayerCardProps) => {
  return (
    <PopupOnOverlayComponent
      expandedChildren={() => [
        <PlayerCardComponent
          key={props.key}
          player={props.player}
          cardDimensions={props.expandedCardSize ?? LargeCard}
          showTutorials={true}
          inLine={false}
        />,
        props.actions,
      ]}
      blockExpand={props.blockExpand}
    >
      {props.alternateChildren ?? (
        <PlayerCardComponent
          {...props}
          cardDimensions={props.dimensions ?? SmallCard}
          onClick={() => {
            if (props.onClick) {
              props.onClick();
            }
          }}
        />
      )}
    </PopupOnOverlayComponent>
  );
};
